import _get from "lodash.get";
var AudioHandler = /** @class */ (function () {
    function AudioHandler() {
    }
    AudioHandler.getInstance = function () {
        if (!this._instance) {
            this._instance = new AudioHandler();
        }
        return this._instance;
    };
    AudioHandler.prototype.load = function (scene) {
        this.scene = scene;
        this.audio = {
            notification: [
                this.scene.sound.add("kill.double"),
                this.scene.sound.add("kill.triple"),
                this.scene.sound.add("kill.multi"),
                this.scene.sound.add("kill.ultra"),
                this.scene.sound.add("kill.mega"),
                this.scene.sound.add("kill.invincible"),
                this.scene.sound.add("kill.massacre"),
                this.scene.sound.add("kill.unstoppable"),
            ],
            player: {
                attack: this.scene.sound.add("player.attack"),
                death: [
                    this.scene.sound.add("player.death"),
                    this.scene.sound.add("player.death.alternative"),
                    this.scene.sound.add("player.damage"),
                ],
            },
            point: {
                pickup: this.scene.sound.add("player.pickup"),
            },
        };
    };
    AudioHandler.prototype.play = function (key) {
        var audio = _get(this.audio, key);
        audio === null || audio === void 0 ? void 0 : audio.play({});
    };
    return AudioHandler;
}());
export default AudioHandler;
